import { useState, useEffect } from 'react';

const useMediaQuery = (query: string): boolean | null => {
  if (typeof window === 'undefined') return null;

  const windowQuery = query.replace(/^@media( ?)/m, '');

  const supportMatchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  if (!supportMatchMedia) return false;
  const mediaQuery = window.matchMedia(windowQuery);

  const [isMatching, setIsMatching] = useState(() => mediaQuery.matches);

  const checkIfIsMatching = (): void => {
    setIsMatching(window.matchMedia(windowQuery).matches);
  };

  useEffect(() => {
    mediaQuery.addListener(checkIfIsMatching);
    return (): void => {
      mediaQuery.removeListener(checkIfIsMatching);
    };
  }, [query, supportMatchMedia]);

  return isMatching;
};

export default useMediaQuery;
